import { apiService } from "./api.service";
import { PaginatedResponse } from "types/index";
import { ContactUs } from "types/contactus";

class ContactUsService {
  async getAll(): Promise<ContactUs[]> {
    const response = await apiService.get<any>(`/ContactUs/GetAll`, {
      // Do not trigger global loader when fetching messages
      // to avoid blocking UI with a page-level spinner.
      metadata: { skipGlobalLoading: true },
    } as any);

    const payload: any = (response as any)?.data ?? response;
    if (Array.isArray(payload)) {
      return payload as ContactUs[];
    }
    if (Array.isArray((payload as any)?.data)) {
      return (payload as any).data as ContactUs[];
    }
    if (Array.isArray((response as any)?.items)) {
      return (response as any).items as ContactUs[];
    }
    throw new Error((response as any)?.message || "Failed to load messages");
  }

  async list(
    page: number = 1,
    limit: number = 100
  ): Promise<PaginatedResponse<ContactUs>> {
    const response = await apiService.get<any>(`/ContactUs/GetAll`);

    const payload: any = (response as any)?.data ?? response;
    let messages: ContactUs[] = [];
    
    if (Array.isArray(payload)) {
      messages = payload as ContactUs[];
    } else if (Array.isArray((payload as any)?.data)) {
      messages = (payload as any).data as ContactUs[];
    } else if (Array.isArray((response as any)?.items)) {
      messages = (response as any).items as ContactUs[];
    } else {
      throw new Error((response as any)?.message || "Failed to load messages");
    }

    // Since GetAll returns all messages, we need to implement client-side pagination
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = messages.slice(startIndex, endIndex);
    const totalPages = Math.max(1, Math.ceil(messages.length / limit));

    return {
      data: paginatedData,
      pagination: { page, limit, total: messages.length, totalPages },
    };
  }

  async getById(id: string): Promise<ContactUs> {
    const response = await apiService.get<any>(`/ContactUs/${id}`);
    const payload: any = (response as any)?.data ?? response;

    const contactUsData =
      payload?.data && typeof payload.data === "object"
        ? payload.data
        : typeof payload === "object"
        ? payload
        : null;

    if (contactUsData) {
      return contactUsData as ContactUs;
    }

    return response as unknown as ContactUs;
  }
  
    async create(payload: Partial<ContactUs>): Promise<ContactUs> {
      const response = await apiService.post<ContactUs>(`/ContactUs`, payload);
      if ((response as any)?.data && (response as any)?.success !== false) {
        return (response as any).data as ContactUs;
      }
      return response as any as ContactUs;
    }
  
}

export const contactUsService = new ContactUsService();
export default contactUsService;
